"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var SearchBox_base_1 = require("./SearchBox.base");
var SearchBox_styles_1 = require("./SearchBox.styles");
exports.SearchBox = Utilities_1.styled(SearchBox_base_1.SearchBoxBase, SearchBox_styles_1.getStyles);
//# sourceMappingURL=SearchBox.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/SearchBox/SearchBox.js
// module id = 1644
// module chunks = 0